// DashboardRoutes.js
import React from "react";
import { Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar from "../Components/Sidebar/Sidebar";

import Users from "../Pages/All/Users/Users";
import Product from "../Pages/All/Product/Product";
import Chat from "../Pages/All/Chat/Chat";
import Order from "../Pages/All/Order/Order";
import Coupon from "../Pages/All/Coupon/Coupon";
import PageLinks from "../Pages/All/PageLinks/HomePageLinks";
import Voucher from "../Pages/All/Voucher/Voucher";
import Controller from "../Pages/All/Controller/Controller";
import Notification from "../Pages/All/Notifications/Notification";
import Dashboard from "../Pages/All/Dashboard/Dashboard";
import WorkoutPlans from "../Pages/All/Workout/WorkoutPlans/WorkoutPlans";
import RecipePlans from "../Pages/All/Workout/RecipePlans/RecipePlans";
import WeeklyChallanges from "../Pages/All/Workout/WeeklyChallanges/WeeklyChallanges";
import DietPlans from "../Pages/All/Workout/DietPlans/DietPlans";
import Questions from "../Pages/All/Workout/Q&A/Questions";
import PremiumUsers from "../Pages/All/Users/PremiumUser";
import Setting from "../Pages/All/Setting/Setting";
import Policy from "../Pages/All/Privacy/Privacy";
import AboutUs from "../Pages/All/About/About";



const DashboardRoutes = () => {
  return (
    <Box sx={{ display: "flex", width: "100%",height: "100vh" }}>
      <Box>
        <Sidebar />
      </Box>

      <Box sx={{ ml: { sm: "0px", md: "290px", lg: "290px" }, width: "100%", }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/premiumusers" element={<PremiumUsers />} />
          <Route path="/product" element={<Product />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/order" element={<Order />} />
          <Route path="/coupon" element={<Coupon />} />
          <Route path="/pagelinks" element={<PageLinks />} />
          <Route path="/voucher" element={<Voucher />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/controller" element={<Controller />} />
          <Route path="/notification" element={<Notification />} />
          <Route path="/workoutplans" element={<WorkoutPlans />} />
          <Route path="/recipeplans" element={<RecipePlans />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/dietplans" element={<DietPlans />} />
          <Route path="/weeklychallanges" element={<WeeklyChallanges />} />
          <Route path="/privacy" element={<Policy />} />
          <Route path="/about" element={<AboutUs />} />


        </Routes>
      </Box>
    </Box>
  );
};

export default DashboardRoutes;
